export default __webpack_public_path__ + "static/media/fact_sheet37.581bd71a.png";